import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "flex items-center justify-center",
  style: { height: '100vh', width: '100vw' }
}
const _hoisted_2 = {
  class: "flex flex-col rounded-note border-2 border-charcoal relative rise-animation",
  style: { width: '360px' }
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-center mx-34 my-20" }, "⛲", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "404", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ellipsis-animation mx-34 text-center" }, " your directional components seems to be in the wrong direction ", -1)
const _hoisted_6 = { class: "flex mx-34 my-20 gap-12" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" login ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" foyer ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/login",
          class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: "/-",
          class: "btn-landing text-charcoal p-cell rounded-mention flex-grow text-center"
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ])
    ])
  ]))
}